/* Episode Silver — product page behaviour
   Loaded by sections/product-template.liquid.

   Three independent pieces, each a no-op when its markup is absent:
     1. Slider arrows wired to the existing Flickity instance
     2. Lightbox corrections
     3. Personalisation rows

   No Liquid, no per-product ids. Everything is found by data attribute, so this
   file is static and cacheable.
*/
(function () {
  'use strict';

  /* ------------------------------------------------ 1. Slider side navigation */

  function initSideNav() {
    var nav = document.querySelector('[data-episode-sidenav]');
    if (!nav) { return; }

    var slideshow = document.querySelector('.product-slideshow');
    var frame = document.querySelector('.product__main-photos');

    if (!slideshow || !frame || slideshow.querySelectorAll('.product-main-slide').length < 2) {
      if (nav.parentNode) { nav.parentNode.removeChild(nav); }
      return;
    }

    frame.appendChild(nav);
    nav.removeAttribute('hidden');

    function move(forward) {
      if (window.Flickity && typeof window.Flickity.data === 'function') {
        var instance = window.Flickity.data(slideshow);
        if (instance) {
          if (forward) { instance.next(true); } else { instance.previous(true); }
          return;
        }
      }
      if (window.jQuery && window.jQuery(slideshow).flickity) {
        window.jQuery(slideshow).flickity(forward ? 'next' : 'previous', true);
      }
    }

    var prev = nav.querySelector('.product-side-nav__btn--prev');
    var next = nav.querySelector('.product-side-nav__btn--next');
    if (prev) { prev.addEventListener('click', function () { move(false); }); }
    if (next) { next.addEventListener('click', function () { move(true); }); }
  }

  /* ------------------------------------------------------------- 2. Lightbox */

  function patchPhotoSwipe() {
    function wrap(Original) {
      if (typeof Original !== 'function' || Original.__episodeLightbox) { return Original; }

      var Patched = function (el, ui, items, options) {
        options = options || {};

        /* Open as a fade rather than a zoom from the thumbnail. The thumbnail
           bounds are the square frame, not the letterboxed photo inside it, so a
           zoom-from-thumb animation starts from the wrong rectangle. */
        options.showHideOpacity = true;
        options.getThumbBoundsFn = false;
        options.showAnimationDuration = 300;
        options.hideAnimationDuration = 250;

        /* The actual cause of the lightbox opening far too zoomed in.

           The theme opens PhotoSwipe with scaleMode 'zoom' and initialZoomLevel
           0.5, which means "show the photo at half its natural pixel size" and
           ignores the screen entirely. Measured on this store: a 2000px master
           opens at 1000 CSS pixels tall on every device. On a desktop that is a
           little taller than the window, so the photo is cropped top and bottom
           and it reads as slightly off. On a phone about 390 CSS pixels wide it
           is roughly two and a half times the screen, which is the report.

           It also got worse rather than better when the set images were replaced
           with 2000 by 2000 masters, because the overscale is a fraction of the
           file's own size. That is why it looked like a regression.

           scaleMode 'fit' makes PhotoSwipe use its own fitRatio, which it already
           computes correctly from the live viewport. Verified: fitRatio 0.45,
           initialZoomLevel 0.45, photo exactly inside the window with nothing
           cropped. Nothing else about zooming is touched. maxSpreadZoom and the
           double tap step are left at the theme's values, because every attempt to
           correct those from out here produced a different wrong answer on a phone
           than on a desktop. */
        options.scaleMode = 'fit';
        return new Original(el, ui, items, options);
      };

      Patched.prototype = Original.prototype;
      Patched.__episodeLightbox = true;
      return Patched;
    }

    /* The library may already be present, or may be loaded on the first zoom. A
       property hook covers both orders without polling. */
    var current = window.PhotoSwipe;
    try {
      Object.defineProperty(window, 'PhotoSwipe', {
        configurable: true,
        get: function () { return current; },
        set: function (value) { current = wrap(value); }
      });
      if (current) { current = wrap(current); }
    } catch (e) {
      if (current) { window.PhotoSwipe = wrap(current); }
    }
  }

  function initTapToZoom() {
    /* The theme already opens the lightbox from an image tap in some contexts, so
       firing the magnifier unconditionally opens and immediately closes it. This
       waits to see whether the lightbox appeared on its own and only steps in when
       it did not. A drag is never treated as a tap, so swiping still works. */
    var startX = 0;
    var startY = 0;

    document.addEventListener('pointerdown', function (event) {
      if (!event.target.closest) { return; }
      if (!event.target.closest('.product-main-slide .image-wrap')) { return; }
      startX = event.clientX;
      startY = event.clientY;
    }, true);

    document.addEventListener('pointerup', function (event) {
      if (!event.target.closest) { return; }

      var wrapEl = event.target.closest('.product-main-slide .image-wrap');
      if (!wrapEl) { return; }
      if (event.target.closest('button, a')) { return; }
      if (Math.abs(event.clientX - startX) > 10 || Math.abs(event.clientY - startY) > 10) { return; }

      var slide = wrapEl.closest('.product-main-slide');
      var zoom = slide && slide.querySelector('.js-photoswipe__zoom');
      if (!zoom) { return; }

      window.setTimeout(function () {
        if (document.querySelector('.pswp--open')) { return; }
        zoom.click();
      }, 180);
    }, true);
  }

  /* --------------------------------------------------- 3. Personalisation rows */

  function initPersonalisation() {
    var block = document.querySelector('[data-episode-pers]');
    if (!block) { return; }

    var form = document.querySelector('form.product-single__form');
    if (!form) {
      if (block.parentNode) { block.parentNode.removeChild(block); }
      return;
    }

    /* Sit directly above the buy buttons, inside the form so the fields post. */
    var anchor = form.querySelector('.payment-buttons') || form.querySelector('.product__quantity');
    if (anchor) { form.insertBefore(block, anchor); } else { form.appendChild(block); }
    block.removeAttribute('hidden');

    var row = block.querySelector('[data-pers-engraving-row]');
    var slot = block.querySelector('[data-pers-engraving-slot]');

    /* Some products already carry a Message field from the app. Where that is the
       case, move it into the gift message row and drop our textarea, so a shopper
       never sees two boxes asking for the same thing. */
    function adoptAppMessage(io) {
      var appMessage = io.querySelector('[name="properties[Message]"]');
      if (!appMessage) { return; }

      var group = appMessage;
      while (group.parentNode && group.parentNode !== io) { group = group.parentNode; }
      if (group.parentNode !== io) { return; }

      var rows = block.querySelectorAll('.pers__row');
      var msgBody = rows.length ? rows[rows.length - 1].querySelector('.pers__body') : null;
      if (!msgBody) { return; }

      var mine = msgBody.querySelector('.pers__textarea');
      var counter = msgBody.querySelector('[data-pers-count]');
      if (mine) { mine.parentNode.removeChild(mine); }
      if (counter) { counter.parentNode.removeChild(counter); }
      msgBody.appendChild(group);
    }

    /* The app injects late and on its own schedule, so watch for it. */
    var tries = 0;
    (function grab() {
      var io = document.getElementById('infiniteoptions-container');
      if (io) {
        if (slot && !slot.contains(io)) { slot.appendChild(io); }
        io.style.display = '';
        adoptAppMessage(io);
        return;
      }
      if (++tries > 40) {
        if (row && row.parentNode) { row.parentNode.removeChild(row); }
        return;
      }
      window.setTimeout(grab, 250);
    })();

    /* Character counter, and drop the property when blank so the order does not
       carry an empty line. */
    var textarea = block.querySelector('.pers__textarea');
    var count = block.querySelector('[data-pers-count]');
    if (textarea) {
      var max = textarea.getAttribute('maxlength');
      var sync = function () {
        if (count) { count.textContent = textarea.value.length + ' / ' + max; }
      };
      textarea.addEventListener('input', sync);
      sync();
      form.addEventListener('submit', function () {
        if (!textarea.value.trim()) { textarea.disabled = true; }
      });
    }
  }

  /* ------------------------------ 4. Delivery note on other Rakhi products */

  function initRakhiNote() {
    var note = document.querySelector('[data-episode-rakhi-note]');
    if (!note) { return; }

    /* Rendered at the end of the section and moved up under the price, so it
       reads the same way it does on the gift sets. */
    var meta = document.querySelector('.product-single__meta');
    var price = meta ? (meta.querySelector('.product__price') || meta.querySelector('.product-single__price')) : null;
    var after = price ? (price.closest('.product__policies') || price.parentNode) : null;

    if (!meta) { if (note.parentNode) { note.parentNode.removeChild(note); } return; }

    if (after && after.parentNode === meta) {
      meta.insertBefore(note, after.nextSibling);
    } else {
      meta.insertBefore(note, meta.firstChild);
    }
    note.removeAttribute('hidden');
  }

  /* ------------------------------------------- 5. Gift set tag placement */

  function initGiftsetTag() {
    var tag = document.querySelector('.giftset-tag');
    if (!tag) { return; }

    /* Rendered at the end of the section and moved up beside the title, because
       the title itself is drawn deep inside snippets/product-template.liquid. */
    var meta = document.querySelector('.product-single__meta--giftset') || document.querySelector('.product-single__meta');
    var title = meta ? meta.querySelector('.product-single__title') : null;
    if (!title || !title.parentNode) { return; }

    title.parentNode.insertBefore(tag, title.nextSibling);
    tag.classList.add('giftset-tag--placed');
  }

  /* ------------------------------------------------------------------- Boot */

  patchPhotoSwipe();
  initTapToZoom();

  function boot() {
    initSideNav();
    initRakhiNote();
    initGiftsetTag();
    initPersonalisation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
